<template>
  <div class="sub-section">
    <b-field
      class="input-field"
      label="Dimension"
      :type="errors.length ? 'is-danger' : ''"
      :message="errors.map(e => e.msg).join(', ')">
      <CompanyDimensionRefSelect v-model="inputs" />
    </b-field>
  </div>
</template>

<script>

  import CompanyDimensionRefSelect from '@/components/reports/config/dimensions/CompanyDimensionRefSelect'

  export default {
    name: 'DimensionTab',
    components: {
      CompanyDimensionRefSelect,
    },
    props: {
      value: {
        type: Object,
        default: () => {},
      },
      errors: {
        type: Array,
        default: () => [],
      },
    },
    computed: {

      inputs: {
        get () {
          return this.value || {}
        },
        set (value) {
          this.$emit('input', value ? value : null)
        },
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
